import { render, staticRenderFns } from "./PredefinedFilter.vue?vue&type=template&id=e2738860&scoped=true&"
import script from "./PredefinedFilter.vue?vue&type=script&lang=js&"
export * from "./PredefinedFilter.vue?vue&type=script&lang=js&"
import style0 from "./PredefinedFilter.vue?vue&type=style&index=0&id=e2738860&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2738860",
  null
  
)

export default component.exports